import { type Account, Roles } from '@prisma/client'
import { createAction, createReducer } from '@reduxjs/toolkit'

/**
 * STATE
 */
export interface UserState extends Partial<Account> {}

export const initialState: UserState = {
  id: 0,
  role: Roles.GUEST,
  avatar: '',
  displayName: ''
}

/**
 * ACTION's
 */
export enum ActionTypes {
  SET_PROFILE = 'SET_USER_PROFILE'
}

export const setProfile = createAction<Partial<Account>, ActionTypes>(ActionTypes.SET_PROFILE)

/**
 * REDUCER's
 */
export default createReducer(initialState, (builder) => {
  return builder.addCase(setProfile, (state, { payload }) => {
    Object.assign(state, payload)
  })
})
